interface ButtonProps {
  disabled?: boolean
  type?: 'submit' | 'reset' | 'button'
  className?: string
  title: string
  onClick?: () => void
}

export function Button({
  disabled,
  type,
  className,
  title,
  onClick,
}: ButtonProps) {
  const baseClasses =
    'text-sm font-semibold flex-none rounded-xl uppercase px-5 py-2.5 text-dw-black shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 transition-all'

  const disabledClasses = disabled
    ? 'opacity-50 cursor-not-allowed bg-gray-400 text-gray-500'
    : ''

  return (
    <button
      disabled={disabled}
      type={type}
      className={`${className} ${baseClasses} ${disabledClasses}`}
      onClick={onClick}
    >
      {title}
    </button>
  )
}
